import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { usersClient } from "@core/clients";
import { useAuth } from "../../contexts/auth-context";
import { User } from "@core/types";
import { queryClient } from "../../config/query-client";

type Options = UseMutationOptions<User, any>;

const useGetMeMutation = (options?: Options) => {
  const { user, login } = useAuth();
  return useMutation(
    ["get-me-mutation"],
    async () => {
      return await usersClient.getProfile("");
    },
    {
      ...options,
      onSuccess: (data) => {
        login({
          ...data,
          ...user,
        });
        console.log("data", data);
        queryClient.invalidateQueries(["get-profile", data.id]);
      },
    },
  );
};

export default useGetMeMutation;
